/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import {
    CONFIRMATION_TYPES,
    CONFIRMATION_BOX_BTN_IDS,
} from '../utils/modelMapper/appModelMapper/confirmationDialog/confirmationDialogConstants';

export const DIALOG_BUTTON_VALUES = {
    [CONFIRMATION_TYPES.UNINSTALL_PREFERENCES]: {
        cta: {
            [CONFIRMATION_BOX_BTN_IDS.PRIMARY]: 'keep-preferences',
            [CONFIRMATION_BOX_BTN_IDS.SECONDARY]: 'remove-preferences',
            [CONFIRMATION_BOX_BTN_IDS.TERTIARY]: 'cancel',
        },
        subcategory: 'Uninstall',
    },
    [CONFIRMATION_TYPES.FULL_APP_UPDATE_CONFIRMATION_WITH_ADVANCED_OPTIONS]: {
        cta: {
            [CONFIRMATION_BOX_BTN_IDS.PRIMARY]: 'continue',
            [CONFIRMATION_BOX_BTN_IDS.SECONDARY]: 'cancel',
        },
        subcategory: 'Update',
    },
    [CONFIRMATION_TYPES.AUTO_UPDATE_WITH_ADVANCED_OPTIONS]: {
        cta: {
            [CONFIRMATION_BOX_BTN_IDS.PRIMARY]: 'continue',
            [CONFIRMATION_BOX_BTN_IDS.SECONDARY]: 'cancel',
        },
        subcategory: 'Auto Update',
    },
    [CONFIRMATION_TYPES.DISABLE_AU_FOR_INSTALL]: {
        cta: {
            [CONFIRMATION_BOX_BTN_IDS.PRIMARY]: 'continue',
            [CONFIRMATION_BOX_BTN_IDS.SECONDARY]: 'cancel',
            [CONFIRMATION_BOX_BTN_IDS.TERTIARY]: 'cancel',
        },
        subcategory: 'Disable AU Install',
    },
    [CONFIRMATION_TYPES.DISABLE_AU_FOR_UNINSTALL]: {
        cta: {
            [CONFIRMATION_BOX_BTN_IDS.PRIMARY]: 'continue',
            [CONFIRMATION_BOX_BTN_IDS.SECONDARY]: 'cancel',
            [CONFIRMATION_BOX_BTN_IDS.TERTIARY]: 'cancel',
        },
        subcategory: 'Disable AU Uninstall',
    },
    [CONFIRMATION_TYPES.PREV_VER_WITH_DISABLED_AU]: {
        cta: {
            [CONFIRMATION_BOX_BTN_IDS.PRIMARY]: 'continue',
            [CONFIRMATION_BOX_BTN_IDS.SECONDARY]: 'cancel',
            [CONFIRMATION_BOX_BTN_IDS.TERTIARY]: 'cancel',
        },
        subcategory: 'Previous Version Disabled AU',
    },
    [CONFIRMATION_TYPES.PREV_VER]: {
        cta: {
            [CONFIRMATION_BOX_BTN_IDS.PRIMARY]: 'continue',
            [CONFIRMATION_BOX_BTN_IDS.SECONDARY]: 'cancel',
            [CONFIRMATION_BOX_BTN_IDS.TERTIARY]: 'cancel',
        },
        subcategory: 'Previous Version',
    },
    [CONFIRMATION_TYPES.CONFLICTING_PROCESS]: {
        cta: {
            [CONFIRMATION_BOX_BTN_IDS.PRIMARY]: 'continue',
            [CONFIRMATION_BOX_BTN_IDS.TERTIARY]: 'cancel',
        },
        subcategory: 'Conflict',
    },
    [CONFIRMATION_TYPES.PII]: {
        cta: {
            [CONFIRMATION_BOX_BTN_IDS.PRIMARY]: 'continue',
            [CONFIRMATION_BOX_BTN_IDS.SECONDARY]: 'back',
        },
        subcategory: 'PII',
    },
    [CONFIRMATION_TYPES.RETRYABLE_ERROR]: {
        cta: {
            [CONFIRMATION_BOX_BTN_IDS.DONE]: 'done',
        },
        subcategory: 'Retryable Error',
    },
    [CONFIRMATION_TYPES.LAUNCH_CONFIRMATION]: {
        cta: {
            [CONFIRMATION_BOX_BTN_IDS.PRIMARY]: 'continue',
            [CONFIRMATION_BOX_BTN_IDS.SECONDARY]: 'cancel',
        },
        subcategory: 'App Open',
    },
    [CONFIRMATION_TYPES.ELEVATION_INFO]: {
        cta: {
            [CONFIRMATION_BOX_BTN_IDS.PRIMARY]: 'continue',
	        [CONFIRMATION_BOX_BTN_IDS.SECONDARY]: 'cancel',
        },
        subcategory: 'Elevation Prompt Info',
    },
    [CONFIRMATION_TYPES.ERROR_INFO]: {
        cta: {
            [CONFIRMATION_BOX_BTN_IDS.RETRY]: 'retry',
            [CONFIRMATION_BOX_BTN_IDS.CANCEL]: 'cancel',
        },
        subcategory: 'Error Info',
    },
};
